// extracted by mini-css-extract-plugin
export default {"button":"button-return_button__NRsRy","text":"button-return_text__SxI0W"};